import { gql } from "@apollo/client";

export const VALIDATE_INVITE_LINK = gql`
    query ValidateInviteLink($code: String!) {
        validateInviteLink(code: $code)
    }
`;